(() => {
  angular
    .module('gm.common.filters')
    .filter('gmyFormatRecurringPeriod', gmyFormatRecurringPeriod);

  function gmyFormatRecurringPeriod(
    $window
  ) {
    'ngInject';

    const formatRecurring = (input) => {
      const destination = $window.moment.duration(input);
      let period = destination.humanize();

      let word = period.match(/([a-z]+)/);
      if (word) {
        word = word[1];
        const wordUp = word.substr(0, 1).toUpperCase() + word.substr(1);
        period = period.replace(word, wordUp);
      }

      return period;
    };
    formatRecurring.$stateful = true;

    return formatRecurring;
  }
})();
